import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";
export default {
    tagBackgroundColor: BACKGROUND_GRAY_COLOR_NAME
};
